import React from 'react';
import {
  Col,
  FormFeedback,
  FormGroup,
  Input,
  Label,
  Row,
} from 'reactstrap';
import TextInput from '../../../components/TextInput';
import Text from '../../../components/Text';

import provinces from './provinces.json';

export default function LeadsEmployerAddressView(props) {
  return (
    <>
      <TextInput
        name="employerAddress"
        label="Employer Address"
        validationData={props.validations}
        formData={props.formData}
        onChange={props.onChange}
        required
      />
      <TextInput
        name="employerCity"
        label="Employer City"
        validationData={props.validations}
        formData={props.formData}
        onChange={props.onChange}
        required
      />
      <TextInput
        name="employerPostalCode"
        label="Employer Postal Code"
        validationData={props.validations}
        formData={props.formData}
        onChange={props.onChange}
        required
      />
      <FormGroup>
        <Row>
          <Col sm="auto" className="label-main">
            <Label htmlFor="employerProvince">
              <Text value="Employer Province" />
            </Label>
          </Col>
        </Row>
        <Input
          type="select"
          name="employerProvince"
          id="employerProvince"
          value={props.formData.employerProvince}
          onChange={props.onChange}
          invalid={props.validations.employerProvince?.isInvalid}
        >
          <option value="">Select your province</option>
          {
            provinces.map((i) => (
              <option key={i.code} value={i.code}>
                { i.name }
              </option>
            ))
          }
        </Input>
        <FormFeedback>{ props.validations.employerProvince?.message }</FormFeedback>
      </FormGroup>
    </>
  );
}
